import { BaseModel } from "../../base/models/base-model.model";
import { ContractState } from "../../shared/DTO/contractState";
import { OrderState } from "../../shared/DTO/orderState";
import { UserType } from "../../shared/DTO/userType";
import { ProductModel } from "./product.model";
import { AgreementModel } from "./agreement.model";
import { OrderFileModel } from "./order-file.model";
import { IdentificationModel } from "./identification.model";
import { PurchaseModel } from "./purchase.model";
import { SubjectModel } from "./subject.model";

export class OrderModel extends BaseModel {
  private _agreements?: Array<AgreementModel>;
  private _insertDate?: string;
  /**
   * Order booking
   */
  private _booking?: boolean;
  private _contractState?: ContractState;
  /**
   * Tipo contratto
   */
  private _contractType?: string;
  private _files?: Array<OrderFileModel>;
  private _identification?: IdentificationModel;
  /**
   * Order operator
   */
  private _operator?: string;
  private _operatorNickname?: string;
  /**
   * Order mailbox
   */
  private _operatorEmail?: string;
  /**
   * Order ID
   */
  private _orderId?: string;
  private _products?: Array<ProductModel>;
  private _purchase?: PurchaseModel;
  private _state?: OrderState;
  private _subjects?: Array<SubjectModel>;
  /**
   * Order unit
   */
  private _unit?: string;
  /**
   * Order user sub-type
   */
  private _userSubType?: string;
  private _userType?: UserType;
  private _accountCode?: string;
  private _customerCode?: string;
  private _commonOrdersId?: string;
  private _externalCommonOrdersId?: string;

  constructor(
    agreements?: Array<AgreementModel>,
    insertDate?: string,
    booking?: boolean,
    contractState?: ContractState,
    contractType?: string,
    files?: Array<OrderFileModel>,
    identification?: IdentificationModel,
    operator?: string,
    operatorEmail?: string,
    orderId?: string,
    products?: Array<ProductModel>,
    purchase?: PurchaseModel,
    state?: OrderState,
    subjects?: Array<SubjectModel>,
    unit?: string,
    userSubType?: string,
    userType?: UserType,
    accountCode?: string,
    customerCode?: string,
    commonOrdersId?: string,
    externalCommonOrdersId?: string,
    operatorNickname?: string
  ) {
    super();
    this._agreements = agreements;
    this._insertDate = insertDate;
    this._booking = booking;
    this._contractState = contractState;
    this._contractType = contractType;
    this._files = files;
    this._identification = identification;
    this._operator = operator;
    this._operatorEmail = operatorEmail;
    this._orderId = orderId;
    this._products = products;
    this._purchase = purchase;
    this._state = state;
    this._subjects = subjects;
    this._unit = unit;
    this._userSubType = userSubType;
    this._userType = userType;
    this._accountCode = accountCode;
    this._customerCode = customerCode;
    this._commonOrdersId = commonOrdersId;
    this._externalCommonOrdersId = externalCommonOrdersId;
    this._operatorNickname = operatorNickname;
  }

  get insertDate(): string {
    return this._insertDate;
  }

  set insertDate(value: string) {
    this._insertDate = value;
  }

  get accountCode(): string {
    return this._accountCode;
  }

  set accountCode(value: string) {
    this._accountCode = value;
  }

  get customerCode(): string {
    return this._customerCode;
  }

  set customerCode(value: string) {
    this._customerCode = value;
  }

  get agreements(): Array<AgreementModel> {
    return this._agreements;
  }

  set agreements(value: Array<AgreementModel>) {
    this._agreements = value;
  }

  get booking(): boolean {
    return this._booking;
  }

  set booking(value: boolean) {
    this._booking = value;
  }

  get contractState(): ContractState {
    return this._contractState;
  }

  set contractState(value: ContractState) {
    this._contractState = value;
  }

  get contractType(): string {
    return this._contractType;
  }

  set contractType(value: string) {
    this._contractType = value;
  }

  get files(): Array<OrderFileModel> {
    return this._files;
  }

  set files(value: Array<OrderFileModel>) {
    this._files = value;
  }

  get identification(): IdentificationModel {
    return this._identification;
  }

  set identification(value: IdentificationModel) {
    this._identification = value;
  }

  get operator(): string {
    return this._operator;
  }

  set operator(value: string) {
    this._operator = value;
  }

  get operatorEmail(): string {
    return this._operatorEmail;
  }

  set operatorEmail(value: string) {
    this._operatorEmail = value;
  }

  get orderId(): string {
    return this._orderId;
  }

  set orderId(value: string) {
    this._orderId = value;
  }

  get products(): Array<ProductModel> {
    return this._products;
  }

  set products(value: Array<ProductModel>) {
    this._products = value;
  }

  get purchase(): PurchaseModel {
    return this._purchase;
  }

  set purchase(value: PurchaseModel) {
    this._purchase = value;
  }

  get state(): OrderState {
    return this._state;
  }

  set state(value: OrderState) {
    this._state = value;
  }

  get subjects(): Array<SubjectModel> {
    return this._subjects;
  }

  set subjects(value: Array<SubjectModel>) {
    this._subjects = value;
  }

  get unit(): string {
    return this._unit;
  }

  set unit(value: string) {
    this._unit = value;
  }

  get userSubType(): string {
    return this._userSubType;
  }

  set userSubType(value: string) {
    this._userSubType = value;
  }

  get userType(): UserType {
    return this._userType;
  }

  set userType(value: UserType) {
    this._userType = value;
  }

  get commonOrdersId(): string {
    return this._commonOrdersId;
  }

  set commonOrdersId(value: string) {
    this._commonOrdersId = value;
  }

  get externalCommonOrdersId(): string {
    return this._externalCommonOrdersId;
  }

  set externalCommonOrdersId(value: string) {
    this._externalCommonOrdersId = value;
  }

  get operatorNickname(): string {
    return this._operatorNickname;
  }

  set operatorNickname(value: string) {
    this._operatorNickname = value;
  }
}
